module.exports = __webpack_public_path__ + "img/ios-save.92b47c8d.svg";